export const heroData = {
  title: "91蜜桃 最新入口地址",
  subtitle: "安全·稳定·极速访问",
  description: "为您提供91蜜桃官方最新入口地址与安全访问指南。收录最新链接、镜像地址及常见问题解答，确保您随时随地安全畅享平台内容。",
  ctaText: "查看最新入口",
  ctaLink: "/category/latest-links",
  secondaryCtaText: "使用指南",
  secondaryCtaLink: "/category/usage-guide",
};

export const latestLinks = [
  {
    id: "link-1",
    label: "主入口",
    url: "https://91mitao.com",
    status: "正常",
    speed: "极速",
    badge: "推荐",
  },
  {
    id: "link-2",
    label: "备用入口一",
    url: "https://91mitao.net",
    status: "正常",
    speed: "快速",
    badge: "",
  },
  {
    id: "link-3",
    label: "备用入口二",
    url: "https://91mitao.org",
    status: "正常",
    speed: "稳定",
    badge: "",
  },
  {
    id: "link-4",
    label: "镜像入口",
    url: "https://mirror.91mitao.com",
    status: "正常",
    speed: "快速",
    badge: "新",
  },
];

export const features = [
  {
    icon: "ri-shield-check-line",
    title: "安全访问",
    description: "所有入口地址均经过安全验证，确保您的访问安全无忧，数据加密传输保护隐私。",
  },
  {
    icon: "ri-rocket-2-line",
    title: "极速连接",
    description: "智能节点调度，自动匹配最优线路，为您提供流畅稳定的访问体验。",
  },
  {
    icon: "ri-refresh-line",
    title: "实时更新",
    description: "入口地址实时监控与更新，确保您始终使用最新有效的访问链接。",
  },
  {
    icon: "ri-guide-line",
    title: "使用指南",
    description: "详细的平台使用教程与常见问题解答，帮助新用户快速上手操作。",
  },
];

export const popularCategories = [
  {
    slug: "latest-links",
    name: "最新入口",
    icon: "ri-link-m",
    description: "91蜜桃最新可用入口地址汇总",
    articleCount: 12,
  },
  {
    slug: "usage-guide",
    name: "使用教程",
    icon: "ri-book-open-line",
    description: "平台功能详细使用说明与技巧",
    articleCount: 8,
  },
  {
    slug: "faq",
    name: "常见问题",
    icon: "ri-question-answer-line",
    description: "用户常见问题及解决方案汇总",
    articleCount: 15,
  },
  {
    slug: "security-guide",
    name: "安全指南",
    icon: "ri-safe-2-line",
    description: "安全访问防护与隐私保护建议",
    articleCount: 6,
  },
  {
    slug: "platform-news",
    name: "平台动态",
    icon: "ri-newspaper-line",
    description: "91蜜桃平台最新公告与更新日志",
    articleCount: 10,
  },
];

export const faqs = [
  {
    question: "如何找到91蜜桃的最新入口地址？",
    answer: "您可以通过本网站首页的「最新入口」区域获取91蜜桃当前可用的所有入口地址。我们实时监控并更新各个入口的状态，推荐使用标记为「推荐」的主入口进行访问。如主入口暂时无法访问，可以尝试备用入口或镜像入口。",
  },
  {
    question: "91蜜桃支持哪些设备访问？",
    answer: "91蜜桃平台全面支持PC端（Windows/Mac）、移动端（iOS/Android手机和平板）以及智能电视等多种设备。您可以通过浏览器直接访问，无需下载额外软件。建议使用最新版本的Chrome、Safari或Edge浏览器以获得最佳体验。",
  },
  {
    question: "访问时遇到页面加载缓慢怎么办？",
    answer: "如果遇到加载缓慢的情况，建议您：1) 尝试切换至其他备用入口；2) 检查当前网络连接状态；3) 清除浏览器缓存后重试；4) 尝试切换网络环境（如从WiFi切换至移动数据）。我们的多节点部署确保您总能找到最优的访问线路。",
  },
  {
    question: "91蜜桃是否需要注册账号？",
    answer: "浏览平台内容时无需注册账号。如需使用收藏、历史记录、评论互动等个性化功能，建议注册一个免费账号。注册过程简单快捷，只需提供基本邮箱即可完成。",
  },
  {
    question: "如何确保访问91蜜桃的安全性？",
    answer: "为确保安全访问，建议您：始终通过本网站提供的官方入口访问；使用HTTPS加密连接；不要在公共WiFi环境下登录个人账号；定期清理浏览器缓存和浏览记录；如有可疑链接或弹窗，请勿点击并立即关闭页面。",
  },
];

export const stats = [
  { value: "50万+", label: "日均活跃用户" },
  { value: "99.9%", label: "服务可用率" },
  { value: "10+", label: "全球加速节点" },
  { value: "5年+", label: "稳定运营时间" },
];